import { removeClass } from './class_helper';

export function allowNumericOnly(element) {
  element.addEventListener('keypress', event => {
    const keyCode = (event.which) ? event.which : event.keyCode;
    // Ensure that it is a number and stop the keypress
    if (!(keyCode >= 48 && keyCode <= 57) && [46, 13].indexOf(keyCode) == -1) {
      event.preventDefault();
      return false;
    }
  });
}

export function setInputValue(input, value) {
  input.value        = value;
  input.defaultValue = value;
}

/**
 * Remove error markers of the given element
 *
 * @param {object} element - The given element on which remove the error's markers
 */
export function removeError(element) {
  removeClass(element, 'is-invalid-label');
  let invalidInput = element.querySelector('.is-invalid-input');
  if (invalidInput) {
    removeClass(element.querySelector('.is-invalid-input'), 'is-invalid-input');
    let errorAnchor = document.getElementById(invalidInput.id+'-error');
    errorAnchor.innerHTML = '';
    errorAnchor.style.display = 'none';
  }
}



// WEBPACK FOOTER //
// ./assets/javascripts/helpers/input_helper.js